import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function newsletterReducer(
  state = initialState.NewsletterData,
  action
) {
  switch (action.type) {
    case types.LOAD_NEWSLETTER_DATA_SUCCESS:
      return action.NewsletterData;
    default:
      return state;
  }
}
